import type { SiteRagReport } from '../../types/siteRag';
import type { SupplyChainPlan } from '../../types/supplyChain';

export function resolveSupplyChainPlan(report: SiteRagReport): SupplyChainPlan | undefined {
  const plan = report.supplyChainPlanAtGen;
  if (!plan?.bom?.length && !plan?.suppliers?.length && !plan?.quotes?.length) {
    return undefined;
  }
  return plan;
}

export function scmRiskItems(report: SiteRagReport) {
  return (report.risks ?? []).filter((r) => {
    const id = r.id ?? '';
    const label = r.label ?? '';
    return id.startsWith('scm-') || /supply|procurement|lead.?time|transformer|switchgear|supplier/i.test(label);
  });
}
